import { AzureIndex } from "@/pages/Messaging/Bots/types";
import React from "react";
export const AzureIndexesContext = React.createContext<{
  azureIndexes: AzureIndex[];
  loading: boolean;
  error: string | null;
  add(index: AzureIndex): void;
  remove(id: number): void;
  update(index: AzureIndex): void;
}>({
  azureIndexes: [],
  loading: false,
  error: null,
  add(index: AzureIndex) {},
  remove(id: number) {},
  update(index: AzureIndex) {}
});
